<template>
    <el-container>
        <el-header>
            <el-form :inline="true" :model="formMenu" ref="formMenu" class="demo-form-inline" @submit.native.prevent>
                <td-permission :permissions="permissionsQuery">
                    <template slot="havePermission">
                        <el-form-item :label="$t('common.MENU_NAME')" prop="menuName">
                            <td-input v-model="formMenu.menuName" @keyup.enter.native="btnQuery"></td-input>
                        </el-form-item>
                    </template>
                </td-permission>
                <el-form-item class="paddingLeft10">
                    <td-button @click="btnQuery" :permissions="permissionsQuery" @getPermissionsStatus="getPermissionsStatus" :loading="loading" type="primary">{{ $t('common.QUERY') }}</td-button>
                    <td-button @click="btnAdd" :permissions="permissionsAdd">{{ $t('common.ADD') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :permissions="permissionsQuery"
                :dataSource="tableData"
                :columns="columns"
                :hasTreeTable="hasTreeTable"
                :hasIndex="hasIndex"
                :hasMutiSelect="hasMutiSelect"
                :hasPage="hasPage"
                childrenName="children"
                :hasLoading="hasLoading"
                rowKey="menuId"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-menu
                v-if="dialogMenuVisible"
                :isAddData="isAddData"
                :dialogMenuVisible="dialogMenuVisible"
                :editItem="editItem"
                :title="title"
                :selectOptions="selectOptions"
                @menuDialogClose="menuDialogClose"
                @btnQuery="btnQuery"
            ></dialog-menu>
        </el-main>
    </el-container>
</template>
<script>
import menuApi from './assets/api.js';
import dialogMenu from './components/dialogMenu.vue';
export default {
    components: {
        'dialog-menu': dialogMenu
    },
    data() {
        return {
            permissionsQuery: ['menu:view'],
            permissionsAdd: ['menu:add'],
            permissionsDel: ['menu:del'],
            permissionsEdit: ['menu:edit'],
            permissionsStatus: ['menu:forbiddenMenu'],
            formMenu: {
                menuName: ''
            },
            hasTreeTable: true,
            hasIndex: false,
            hasMutiSelect: false,
            hasPage: false,
            loading: false,
            isAddData: false,
            dialogMenuVisible: false,
            title: '',
            editItem: '',
            hasLoading: false,
            selectOptions: [],
            columns: [
                {
                    label: 'common.MENU_NAME',
                    prop: 'menuName'
                },
                {
                    label: 'common.MENU_URL',
                    prop: 'menuUrl',
                    showOverflowTooltip: true
                },
                {
                    label: 'common.MENU_SORT',
                    prop: 'menuSort',
                    align: 'center',
                    tableWidth: '80'
                },
                {
                    label: 'common.MENU_ICON_URL',
                    prop: 'menuIconUrl',
                    showOverflowTooltip: true
                },
                {
                    label: 'common.MENU_ICON',
                    prop: 'menuIcon',
                    tableWidth: '230',
                    showOverflowTooltip: true
                },
                {
                    label: 'common.PLUGIN_NAME',
                    prop: 'pluginName',
                    tableWidth: '150',
                    showOverflowTooltip: true
                },
                {
                    label: 'common.OPERATE',
                    tableWidth: '120',
                    align: 'center',
                    render: (createElement, params) => {
                        if (params.row.moduleId === 'sys_base_module') {
                            return '';
                        }
                        let operateList = [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: this.permissionsEdit },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: this.permissionsDel },
                                    on: {
                                        click: () => {
                                            this.btnDelete(params.row.menuId);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ];
                        let menuStatus;
                        if (params.row.forbiddenFlg == 0) {
                            menuStatus = createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: this.permissionsStatus },
                                    on: {
                                        click: () => {
                                            this.btnMenuStatus(params.row);
                                        }
                                    }
                                },
                                this.$t('common.DISABLE')
                            );
                        } else {
                            menuStatus = createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: this.permissionsStatus },
                                    on: {
                                        click: () => {
                                            this.btnMenuStatus(params.row);
                                        }
                                    }
                                },
                                this.$t('common.ENABLE')
                            );
                        }
                        operateList.push(menuStatus);
                        return createElement('div', operateList);
                    }
                }
            ],
            tableData: []
        };
    },
    methods: {
        getPermissionsStatus(permissions) {
            if (permissions) {
                this.btnQuery();
            }
        },
        btnAdd() {
            this.title = 'common.ADD'; // 标题
            this.isAddData = true;
            this.dialogMenuVisible = true;
        },
        /* 菜单信息编辑 */
        btnExit(row) {
            this.editItem = row;
            this.title = 'common.EDIT';
            this.isAddData = false;
            this.dialogMenuVisible = true;
        },
        /* 菜单信息查询 */
        btnQuery() {
            this.loading = true;
            this.hasLoading = true;
            let param = {
                menuName: this.formMenu.menuName,
                token: sessionStorage.getItem('token')
            };
            menuApi.listMenuInfo(JSON.stringify(param), response => {
                this.hasLoading = false;
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.loading = false;
                    this.$log.error('menuManagement/listMenuInfo', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('menuManagement/listMenuInfo', response.data.message);
                    this.loading = false;
                    return;
                }
                this.loading = false;
                this.tableData = response.data.content;
                /* 处理菜单树形数据 */
                if (param.menuName == '') {
                    this.selectOptions = this.$util.clone(response.data.content);
                    this.selectOptions.unshift(this.$common.topMenuType);
                } else {
                    this.initTreeData();
                }
            });
        },
        /* 初始化树形数据 */
        initTreeData() {
            let _this = this;
            menuApi.listMenuInfo({ token: sessionStorage.getItem('token') }, response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    _this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    _this.$log.error('menuManagement/initTreeData', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    _this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    _this.$log.error('menuManagement/initTreeData', response.data.message);
                    return;
                }
                _this.selectOptions = response.data.content;
                _this.selectOptions.unshift(_this.$common.topMenuType);
            });
        },
        /* 菜单信息删除 */
        btnDelete(menuId) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = { menuId: menuId };
                    menuApi.deleteMenuInfo(param, response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({
                                showClose: true,
                                message: response.data.statusMessage,
                                type: 'error'
                            });
                            this.$log.error('menuManagement/deleteMenuInfo', response.data.statusMessage);
                            return;
                        }
                        this.$message({
                            showClose: true,
                            message: response.data.statusMessage,
                            type: 'success'
                        });
                        this.btnQuery();
                    });
                })
                .catch(() => {});
        },
        /* 菜单禁用 */
        btnMenuStatus(item) {
            let menuStatus = 1;
            if (item.forbiddenFlg == 1) {
                menuStatus = 0;
            }
            let content = {
                menuId: item.menuId,
                forbiddenFlg: menuStatus,
                menuName: item.menuName,
                menuUrl: item.menuUrl,
                parentMenuId: item.parentMenuId,
                menuSort: item.menuSort,
                menuIcon: item.menuIcon,
                describe: item.describe,
                pluginName: item.pluginName,
                moduleId: item.moduleId,
                menuIconUrl: item.menuIconUrl
            };
            menuApi.updateMenuInfo(JSON.stringify(content), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('menuManagement/btnMenuStatus', response.data.statusMessage);
                    return;
                }
                this.btnQuery();
            });
        },
        menuDialogClose() {
            this.dialogMenuVisible = false;
        }
    }
};
</script>
<style></style>
